<template>
<div class="chapter">
<div class="inner_page">
<div class="box">
<p class="fmcenter">TO JEFF</p>
</div>
<p class="copy2">Copyright © 2017 by Susan Branson<br/>All rights reserved.</p>
<p class="copy1">Published by Familius LLC, <a class="htt" href="http://www.familius.com" target="_blank">www.familius.com</a></p>
<p class="copy1">Familius books are available at special discounts for bulk purchases, whether for sales promotions or for family or corporate use. For more information, contact Familius Sales at 559-876-2170 or email <a class="htt" href="mailto:orders@familius.com">orders@familius.com</a>.</p>
<p class="copy1">Reproduction of this book in any manner, in whole or in part,<br/>without written permission of the publisher is prohibited.</p>
<p class="copy1">DISCLAIMER: The material in this book is for informational purposes only. It is not intended to be a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of your physician or other qualified healthcare provider with any questions you may have regarding a medical condition or treatment. Never disregard professional medical advice or delay in seeking it because of something you have read in this book.</p>
<p class="copy1">Library of Congress Cataloging-in-Publication Data<br/>2017932168</p>
<p class="copy1">Print ISBN 9781945547126<br/>Ebook ISBN 9781945547478<br/>Hardcover ISBN 9781945547485</p>
<p class="copy1">Printed in the United States of America</p>
<p class="copy1">Edited by Lindsay Sandberg</p>
<p class="copy">Cover design by David Miles</p>
<p class="copy">Book design by Brooke Jorden and David Miles</p>
<p class="copy1">10 9 8 7 6 5 4 3 2 1</p>
<p class="copy1">First Edition</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?069e5f82